import { Button } from '@mui/material';
import { useConnectToMorning } from '../../hooks/connect-to-morning';
import type { MorningRegisterFormControl } from '../MorningRegisterFormSchema';

interface Props {
  control: MorningRegisterFormControl;
}

export const MorningRegistrationFooter = ({ control }: Props) => {
  const connectToMorning = useConnectToMorning(control);

  const { handleSubmit } = control;
  const submitHandler = handleSubmit((formValues) => connectToMorning(formValues.apiKey, formValues.secretId));

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler}>
        Connect to Morning
      </Button>
    </div>
  );
};
